import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  diasDeAtraso, diasSemPedir, iniciais, linkWhatsApp, moeda, recebeMensagem, segmentoCrm, SegmentoCrm,
  telefoneFormatado, textoDias
} from '../crm-segmentos';

/** Contato do CRM em cartão (Quadro) ou em linha (Fila). */
@Component({
  selector: 'app-cartao-contato-crm',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cartao-contato-crm.component.html',
  styleUrls: ['./cartao-contato-crm.component.scss']
})
export class CartaoContatoCrmComponent {
  @Input() contato: any;
  @Input() modo: 'cartao' | 'linha' = 'cartao';
  @Output() ver = new EventEmitter<any>();
  /** Abre a "Mensagem com a Mia" para este cliente. */
  @Output() mia = new EventEmitter<any>();

  get segmento(): SegmentoCrm {
    return segmentoCrm(this.contato && this.contato.status);
  }

  get iniciais(): string {
    return iniciais(this.contato && this.contato.nome);
  }

  get telefone(): string {
    return telefoneFormatado(this.contato && this.contato.telefone);
  }

  get whatsapp(): string {
    return linkWhatsApp(this.contato);
  }

  get quando(): string {
    return textoDias(diasSemPedir(this.contato));
  }

  get pedidos90d(): number {
    return Number(this.contato && this.contato.pedidos90d) || 0;
  }

  get ticket(): string {
    const valor = Number(this.contato && this.contato.ticketMedio90d);
    return valor > 0 ? moeda(valor) : '';
  }

  get gasto(): string {
    const valor = Number(this.contato && this.contato.gasto90d);
    return valor > 0 ? moeda(valor) : '';
  }

  get ciclo(): number {
    return Number(this.contato && this.contato.cicloRecompraDias) || 0;
  }

  get atraso(): number {
    return diasDeAtraso(this.contato);
  }

  get mostraRitmo(): boolean {
    return this.segmento.mostraAtraso && this.ciclo > 0 && diasSemPedir(this.contato) !== null;
  }

  /** Parte da barra que ainda estava dentro do ritmo de compra. */
  get fracaoEmDia(): number {
    const dias = diasSemPedir(this.contato) || 0;
    if (!dias) return 100;
    return Math.max(8, Math.min(100, Math.round(this.ciclo / dias * 100)));
  }

  get recebe(): boolean {
    return recebeMensagem(this.contato);
  }

  get pedidosTexto(): string {
    const n = this.pedidos90d;
    return n === 1 ? '1 pedido em 90 dias' : `${n} pedidos em 90 dias`;
  }
}
